import {Component, OnInit} from '@angular/core';
import {environment} from '../../../environments/environment';
import {HttpClient} from '@angular/common/http';

@Component({
  selector: 'app-pia-culinaare',
  templateUrl: './pia-culinaare.page.html',
  styleUrls: ['./pia-culinaare.page.scss'],
})
export class PiaCulinaarePage implements OnInit {
  public assets = environment.assets;
  public menuData: any = null;
  public loading = true;
  public error: string = null;
  public allApiData: any = null;
  public restaurantInfo: any = null;
  public information: any = null;
  public selectedDay: string = '0'; // 0 = Monday, 4 = Friday
  public showDebugInfo: boolean = false; // Set to true to show debug information
  public date = new Date();
  public today = new Date();
  public tomorrow = new Date();
  public dayaftertomorrow = new Date();
  public dateSelector: string = 'today';
  public isWeekend: boolean = false;

  constructor(private http: HttpClient) {
    // Initialize to current day of week (Monday = 0, Friday = 4)
    const today = new Date();
    const day = today.getDay();
    const currentDayIndex = day === 0 ? 6 : day - 1;
    this.selectedDay = currentDayIndex < 5 ? currentDayIndex.toString() : '0';
    
    // Initialize dates
    this.tomorrow = new Date(this.tomorrow.setDate(this.today.getDate() + 1));
    this.dayaftertomorrow = new Date(this.dayaftertomorrow.setDate(this.today.getDate() + 2));
    
    // Check if today is weekend
    this.checkWeekend(this.date);
  }

  ngOnInit() {
    this.loadMenuData();
  }

  loadMenuData() {
    this.loading = true;
    this.error = null;
    this.http.get(environment.foodmarket_api).subscribe(
      (data: any) => {
        this.allApiData = data;
        this.menuData = data;
        
        // Extract parkInnovaareLunch data from the API response
        // It's under week.restaurants
        this.restaurantInfo = data.week?.restaurants?.parkInnovaareLunch || 
                             data.week?.restaurants?.parkinnovarelunch ||
                             null;
        
        this.information = data.settings?.informations?.infoparkInnovaareLunch1 || 
                          data.settings?.informations?.infoparkinnovarelunch1 ||
                          null;
        
        this.loading = false;
        
        // Debug logging
        console.log('Full API Data:', data);
        console.log('Week Restaurants:', data.week?.restaurants);
        console.log('Restaurants keys:', data.week?.restaurants ? Object.keys(data.week.restaurants) : 'none');
      console.log('Restaurant Info Found:', this.restaurantInfo);
      if (data.week?.restaurants) {
        console.log('All restaurant keys:', Object.keys(data.week.restaurants));
        Object.keys(data.week.restaurants).forEach(key => {
          console.log(`Restaurant ${key}:`, data.week.restaurants[key]);
          if (data.week.restaurants[key]?.menus) {
            console.log(`  Menus for ${key}:`, Object.keys(data.week.restaurants[key].menus));
          }
        });
      }
        console.log('Menu Types:', this.getMenuTypes());
        console.log('Selected Day:', this.selectedDay);
        console.log('Single Day Types (week):', data.week?.singleDayTypes);
        console.log('Single Day Types keys (week):', data.week?.singleDayTypes ? Object.keys(data.week.singleDayTypes) : 'none');
        
        // Debug: Check menu items for each type
        if (this.restaurantInfo) {
          this.getMenuTypes().forEach(menuType => {
            console.log(`Menu Type: ${menuType}`, this.getMenuItems(menuType, this.selectedDay));
          });
        }
      },
      (error) => {
        this.error = 'Failed to load menu data';
        this.loading = false;
        console.error('Error loading Park Innovaare Lunch data:', error);
      }
    );
  }

  // Get day name
  getDayName(index: string | number): string {
    const idx = typeof index === 'string' ? parseInt(index, 10) : index;
    const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'];
    return days[idx] || '';
  }

  // Get menu items for a specific day and menu type
  getMenuItems(menuType: string, dayIndex: string | number): any[] {
    const index = typeof dayIndex === 'string' ? parseInt(dayIndex, 10) : dayIndex;
    // singleDayTypes is under week.singleDayTypes
    const singleDayTypes = this.menuData?.week?.singleDayTypes || {};
    
    if (!this.menuData || !singleDayTypes) {
      console.log('No menuData or singleDayTypes');
      return [];
    }
    if (!singleDayTypes[menuType]) {
      console.log(`No menu type found: ${menuType}`);
      console.log('Available menu types:', Object.keys(singleDayTypes));
      return [];
    }
    const menuItems = singleDayTypes[menuType];
    if (!Array.isArray(menuItems)) {
      console.log(`Menu items for ${menuType} is not an array:`, menuItems);
      return [];
    }
    const dayMenu = menuItems.find((m: any) => m.weekIndex === index);
    console.log(`Looking for weekIndex ${index} in ${menuType}, found:`, dayMenu);
    return dayMenu ? [dayMenu] : [];
  }

  // Get all menu types for parkInnovaareLunch
  getMenuTypes(): string[] {
    // Try to get restaurantInfo if not already set
    if (!this.restaurantInfo && this.menuData?.week?.restaurants) {
      this.restaurantInfo = this.menuData.week.restaurants.parkInnovaareLunch || null;
      console.log('Retrieved restaurantInfo from menuData:', this.restaurantInfo);
    }
    
    if (!this.restaurantInfo || !this.restaurantInfo.menus) {
      console.log('No restaurantInfo or menus found');
      console.log('RestaurantInfo:', this.restaurantInfo);
      console.log('MenuData restaurants:', this.menuData?.restaurants);
      return [];
    }
    const menuTypes = Object.keys(this.restaurantInfo.menus).sort((a, b) => {
      return (this.restaurantInfo.menus[a].position || 0) - (this.restaurantInfo.menus[b].position || 0);
    });
    console.log('Menu types found:', menuTypes);
    return menuTypes;
  }

  // Get menu type info
  getMenuTypeInfo(menuType: string): any {
    return this.restaurantInfo?.menus?.[menuType] || null;
  }

  // Get week information
  getWeekInfo(): any {
    return this.menuData?.week || null;
  }

  // Get uploaded timestamp
  getUploadedTime(): string {
    return this.menuData?.uploaded || null;
  }

  // Get multiDayTypes
  getMultiDayTypes(): any {
    return this.menuData?.week?.multiDayTypes || null;
  }

  // Get freeChoicePIA
  getFreeChoicePIA(): any {
    return this.getMultiDayTypes()?.freeChoicePIA || null;
  }

  // Get all restaurants
  getRestaurants(): any {
    return this.menuData?.week?.restaurants || {};
  }

  // Get restaurant keys as array
  getRestaurantKeys(): string[] {
    const restaurants = this.getRestaurants();
    if (!restaurants || typeof restaurants !== 'object') return [];
    return Object.keys(restaurants);
  }

  // Get all single day types
  getAllSingleDayTypes(): any {
    return this.menuData?.week?.singleDayTypes || {};
  }

  // Get single day type keys
  getSingleDayTypeKeys(): string[] {
    const types = this.getAllSingleDayTypes();
    if (!types) return [];
    return Object.keys(types);
  }

  // Get soups
  getSoups(): any[] {
    return this.menuData?.week?.soups || [];
  }

  // Get published status
  getPublished(): boolean {
    return this.menuData?.published || false;
  }

  // Get holidays
  getHolidays(): any[] {
    return this.menuData?.holidays || [];
  }

  // Get settings
  getSettings(): any {
    return this.menuData?.settings || null;
  }

  // Get opening hours
  getOpeningHours(): any {
    return this.menuData?.settings?.openingHours || {};
  }

  // Get opening hours keys as array
  getOpeningHoursKeys(): string[] {
    const hours = this.getOpeningHours();
    if (!hours || typeof hours !== 'object') return [];
    return Object.keys(hours);
  }

  // Get Park InnovAare specific opening hours
  getParkInnovaareOpeningHours(): any {
    const hours = this.getOpeningHours();
    return hours?.mittagessenparkinnovaare || null;
  }

  // Get defaults
  getDefaults(): any {
    return this.menuData?.settings?.defaults || {};
  }

  // Get defaults keys as array
  getDefaultsKeys(): string[] {
    const defaults = this.getDefaults();
    if (!defaults || typeof defaults !== 'object') return [];
    return Object.keys(defaults);
  }

  // Get all informations
  getAllInformations(): any {
    return this.menuData?.settings?.informations || {};
  }

  // Get all informations keys as array
  getAllInformationsKeys(): string[] {
    const infos = this.getAllInformations();
    if (!infos || typeof infos !== 'object') return [];
    return Object.keys(infos);
  }

  // Check if date is weekend (Saturday = 5, Sunday = 6)
  checkWeekend(date: Date) {
    const day = date.getDay();
    this.isWeekend = (day === 6) || (day === 0); // Saturday or Sunday
  }

  // Switch date for menu display
  switchDate() {
    if (this.dateSelector === 'today') {
      this.date = this.today;
    } else if (this.dateSelector === 'tomorrow') {
      this.date = this.tomorrow;
    } else if (this.dateSelector === 'dayaftertomorrow') {
      this.date = this.dayaftertomorrow;
    }
    // Check if selected date is weekend
    this.checkWeekend(this.date);
    // Update selectedDay based on the selected date (0 = Monday, 4 = Friday)
    const day = this.date.getDay();
    const currentDayIndex = day === 0 ? 6 : day - 1;
    this.selectedDay = currentDayIndex < 5 ? currentDayIndex.toString() : '0';
  }
}

